import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as styles from './styles.css';
import formControl from './formControl';

class Select extends Component {
  static defaultProps = {
    isEditable: true,
    multi: false,
    testID: undefined,
    disabled: false,
  };

  static propTypes = {
    input: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
      onBlur: PropTypes.func.isRequired,
      value: PropTypes.oneOfType(
        [
          PropTypes.string,
          PropTypes.number,
        ],
      ).isRequired,
    }).isRequired,
    multi: PropTypes.bool,
    isEditable: PropTypes.bool.isRequired,
    testID: PropTypes.string,
    disabled: PropTypes.bool,
    children: PropTypes.node.isRequired,
  };

  normalize = event => (
    this.props.multi ?
      [...event.target.options].filter(o => o.selected).map(o => o.value) :
      event.target.value
  );

  value = () => (this.props.multi && this.props.input.value === '' ? [] : this.props.input.value);

  render() {
    const {
      input: { value, onChange, onBlur, ...otherInputProps },
      multi,
      disabled,
      children,
      isEditable,
      testID,
    } = this.props;

    if (isEditable === false) {
      const matchingChild = React.Children.toArray(children)
        .find(child => (child.props.value === value));
      const label = matchingChild ? matchingChild.props.children : '-';
      return <div className={styles.value}>{label}</div>;
    }

    return (
      <select
        {...otherInputProps}
        multiple={multi}
        className="form-control"
        value={this.value()}
        disabled={disabled}
        onChange={event => onChange(this.normalize(event))}
        onBlur={event => onBlur(this.normalize(event))}
        data-testid={testID}
      >
        {children}
      </select>
    );
  }
}


function SelectDecimal(props) {
  const modifiedProps = {
    ...props,
    input: {
      ...props.input,
      onChange: value => props.input.onChange(parseFloat(value)),
    },
  };

  return (
    <Select
      {...modifiedProps}
    />
  );
}

SelectDecimal.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
};

const wrappedSelectDecimal = formControl(SelectDecimal);

export { wrappedSelectDecimal as SelectDecimal };
export default formControl(Select);
